/**
 * @generated SignedSource<<cdbed6c46059ed5e6109f3de4bf38eab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BillDeleteInput = {
  id: string;
};
export type bill_billDeleteMutation$variables = {
  input: BillDeleteInput;
};
export type bill_billDeleteMutation$data = {
  readonly billDelete: {
    readonly id: string;
  };
};
export type bill_billDeleteMutation = {
  response: bill_billDeleteMutation$data;
  variables: bill_billDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Bill",
    "kind": "LinkedField",
    "name": "billDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bill_billDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bill_billDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "964144472c599da877b33406fb758068",
    "id": null,
    "metadata": {},
    "name": "bill_billDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation bill_billDeleteMutation(\n  $input: BillDeleteInput!\n) {\n  billDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5dc7d21514d355f974f235a14cd1055a";

export default node;
